import { Link } from '@remix-run/react'
import headshot from './dan353x326.jpg'

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			{/* TODO: Add Meta */}
			{/* <Helmet
      title="Daniel Miles"
      meta={[
        {
          name: "description",
          content: "Hi, I'm Dan. I'm here to help with your insurance.",
        },
        {
          name: "keywords",
          content: "Dan Miles, Daniel Miles",
        },
      ]}
    /> */}
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>{' '}
			&rarr;{' '}
			<Link to="/about-us/" className="text-blue-600 underline">
				About Us
			</Link>
			<br />
			<br />
			<h1 className="text-4xl font-black">Dan Miles</h1>
			<span className="image">
				<img src={headshot} alt="Dan Miles" className="rounded-lg" />
			</span>
			<br />
			<br />
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Form CRS:
				<br />
				<ul>
					<li>
						<a
							href="https://www.ameritas.com/OCM/GetFile?doc=567904"
							className="text-blue-600 underline"
							target="_blank"
							rel="noopener noreferrer"
						>
							Ameritas Investment Company, LLC (opens in a new tab)
						</a>
					</li>
					<li>
						<a
							href="https://www.ameritas.com/OCM/GetFile?doc=567905"
							className="text-blue-600 underline"
							target="_blank"
							rel="noopener noreferrer"
						>
							Ameritas Advisory Services, LLC (opens in a new tab)
						</a>
					</li>
				</ul>
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Check the background of Ameritas Investment Company, LLC or this
				investment professional on{' '}
				<a
					href="https://brokercheck.finra.org"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-600 underline"
				>
					FINRA's BrokerCheck (opens in a new tab)
				</a>
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<a
					href="https://calendly.com/daniel-miles"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-600 underline"
				>
					schedule an appointment with Dan (opens in a new tab)
				</a>
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Dan received his Bachelor of Science Degree from Salem State College in
				Salem, MA. He also completed numerous Financial Planning, Estate
				Planning, Investing, and Insurance courses from{' '}
				<a
					href="https://www.theamericancollege.edu/"
					className="text-blue-600 underline"
				>
					The American College (opens in a new tab)
				</a>
				. Prior to entering the financial services and insurance industry, Dan
				worked in the non-profit sector for over 20 years, primarily in the
				development, finance, and research areas.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Since 2004, Dan has been active in the financial planning industry,
				providing objective advice and innovative financial strategies to
				individuals, professionals, and business owners faced with important
				decisions regarding retirement, estate planning, wealth management, and
				advanced insurance applications. He has particular professional
				experience in business succession, estate planning, retirement plans,
				employee benefits, disability, long-term care, and charitable planning.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Dan is the recipient of several awards, including the National Quality
				Award by the National Association of Insurance and Financial Advisors
				(NAIFA), the Agency Growth Award, the Long-Term Care Circle of Champions
				Award, and the Life All Star Award.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Dan holds the Chartered Life Underwriter (CLU) and LUTCF designations
				from The American College and the Certified in Long Term Care (CLTC)
				designation from the Corporation for Long Term Care. Dan is also a
				candidate at The American College for the Chartered Financial Consultant
				(ChFC) and Chartered Advisor in Philanthropy (CAP) designations, and he
				is completing his certifications for the Certified Financial Planner
				(CFP) designation.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Dan maintains Life and Health licenses in NY, OH, MI, MA, and NJ, and
				Securities licenses in MA, NY, and OH. Dan is a Registered
				Representative and Investment Advisor Representative with Ameritas
				Investment Company, a member of FINRA/SIPC.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Dan is a member of several Professional Organizations, including:
			</p>
			<ul>
				<li>
					<a
						href="https://www.naifa.org/"
						className="text-blue-600 underline"
						target="_blank"
						rel="noopener noreferrer"
					>
						National Association of Insurance and Financial Advisors (opens in a
						new tab)
					</a>
				</li>
				<li>
					<a
						href="https://charitablegiftplanners.org/"
						className="text-blue-600 underline"
						target="_blank"
						rel="noopener noreferrer"
					>
						National Association of Charitable Gift Planners (opens in a new
						tab)
					</a>
				</li>
				<li>
					<a
						href="https://www.linkedin.com/company/planned-giving-council-of-upstate-new-york/"
						className="text-blue-600 underline"
						target="_blank"
						rel="noopener noreferrer"
					>
						Planned Giving Council of Upstate New York (opens in a new tab)
					</a>
				</li>
				<li>
					<a
						href="https://www.cancer.org/donate/planned-giving/professional-advisors.html"
						className="text-blue-600 underline"
						target="_blank"
						rel="noopener noreferrer"
					>
						American Cancer Society National Professional Advisors Network
						(opens in a new tab)
					</a>
				</li>
				<li>
					<a
						href="https://www.acga-web.org/"
						className="text-blue-600 underline"
						target="_blank"
						rel="noopener noreferrer"
					>
						American Council on Gift Annuities (opens in a new tab)
					</a>
				</li>
			</ul>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Dan lives in the Rochester area with his wife and three sons.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Dan Miles offers products and services using the following business
				names: Stan Steele Insurance Agency &mdash; insurance and financial
				services | Ameritas Investment Company, LLC (AIC), Member{' '}
				<a
					href="https://www.finra.org/"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-600 underline"
				>
					FINRA (opens in a new tab)
				</a>
				/
				<a
					href="https://www.sipc.org/"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-600 underline"
				>
					SIPC (opens in a new tab)
				</a>{' '}
				- securities and investments. | Ameritas Advisory Services (AAS) –
				investment advisory services. AIC and AAS are not affiliated with the
				Stan Steele Insurance Agency.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Products and services are limited to residents of states where the
				representative is registered. This is not an offer of securities in any
				jurisdiction, nor is it specifically directed to a resident of any
				jurisdiction. As with any security, request a prospectus from your
				representative. Read it carefully before you invest or send money. A
				representative will contact you to provide requested information.
				Representatives of AIC and AAS do not provide tax or legal advice.
				Please consult your tax advisor or attorney regarding your situation.
			</p>
		</main>
	)
}
